export default "__VITE_ASSET__6f0e9233__"